import { EluveError, EluveErrorArgs } from './eluve-error';
import { LogLevel } from './types';

export class ConnectionError extends EluveError {
  static override readonly errorName = 'ConnectionError';
  readonly logLevel: LogLevel = 'error';

  constructor(
    message = 'Failed to establish network connection',
    args?: EluveErrorArgs,
  ) {
    super(message, args);
  }
}
